/*
 * @copyright 2022 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @author 2022 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import axios from '@nextcloud/axios'
import { generateUrl } from '@nextcloud/router'

export async function queryIspdb(host, email) {
	return (await axios.get(generateUrl('/apps/mail/api/autoconfig/ispdb/{host}/{email}', { host, email }))).data.data
}

export async function queryMx(email) {
	return (await axios.get(generateUrl('/apps/mail/api/autoconfig/mx/{email}', { email }))).data.data
}

export async function testConnectivity(host, port) {
	return (await axios.get(generateUrl('/apps/mail/api/autoconfig/test?host={host}&port={port}', { host, port }))).data.data
}
